module.exports = __webpack_public_path__ + "static/media/pic_banner_pricing.3c49ef90.jpg";